// Utilitários dos relatórios: datas, status do aluno, telefones e exportação para Excel.
import * as XLSX from 'xlsx';

const LIMITE_PARADO_MS = 48 * 60 * 60 * 1000;

export function paraData(valor) {
  if (!valor) return null;
  if (typeof valor.toDate === 'function') return valor.toDate();
  if (valor.seconds !== undefined) return new Date(valor.seconds * 1000);
  const d = new Date(valor);
  return isNaN(d.getTime()) ? null : d;
}

export function formatarDataHora(valor) {
  const d = paraData(valor);
  if (!d) return '—';
  return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export function tempoRelativo(valor) {
  const d = paraData(valor);
  if (!d) return '—';
  const minutos = Math.floor((Date.now() - d.getTime()) / 60000);
  if (minutos < 1) return 'agora';
  if (minutos < 60) return `há ${minutos} min`;
  const horas = Math.floor(minutos / 60);
  if (horas < 24) return `há ${horas} h`;
  const dias = Math.floor(horas / 24);
  return dias === 1 ? 'há 1 dia' : `há ${dias} dias`;
}

// Mesmo "telefone" que o bot grava em respostas.telefone (parte antes do @ do contactId)
export function telefoneDoProgresso(progresso) {
  return String(progresso.telefone || String(progresso.contactId || '').split('@')[0]);
}

// Formas do mesmo número: no Brasil, muitas contas de WhatsApp não têm o 9 depois do DDD
export function variantesTelefone(telefone) {
  const d = String(telefone || '').replace(/\D/g, '');
  const variantes = new Set(d ? [d] : []);
  if (d.startsWith('55') && d.length === 13 && d[4] === '9') variantes.add(d.slice(0, 4) + d.slice(5));
  if (d.startsWith('55') && d.length === 12) variantes.add(`${d.slice(0, 4)}9${d.slice(4)}`);
  return [...variantes];
}

export function formatarTelefone(digitos, contactId) {
  const d = String(digitos || '').replace(/\D/g, '');
  if (String(contactId || '').endsWith('@lid')) return `ID WhatsApp ${d}`;
  if (d.startsWith('55') && d.length === 13) return `+55 (${d.slice(2, 4)}) ${d.slice(4, 9)}-${d.slice(9)}`;
  if (d.startsWith('55') && d.length === 12) return `+55 (${d.slice(2, 4)}) ${d.slice(4, 8)}-${d.slice(8)}`;
  return d || '—';
}

// Mesma regra do painel de cursos: parado = não concluiu e está há mais de 48h sem avançar
export function estaParado(progresso) {
  if (progresso.concluido || progresso.statusEtapa === 'Pausado') return false; // pausado pelo aluno não é abandono
  const ultima = paraData(progresso.timestampUltimaEtapa);
  return !ultima || Date.now() - ultima.getTime() > LIMITE_PARADO_MS;
}

// Concluiu de fato (o "Interrompido" pelo painel também fica com concluido: true)
export const concluiuCurso = (progresso) => progresso.concluido && progresso.statusAprovacao !== 'Interrompido';

export function statusDoAluno(progresso) {
  if (progresso.statusAprovacao === 'Interrompido') return { rotulo: 'Interrompido', tom: 'neutral' };
  if (progresso.concluido) {
    if (progresso.statusAprovacao === 'Reprovado') return { rotulo: 'Reprovado', tom: 'danger' };
    return { rotulo: progresso.statusAprovacao === 'Aprovado' ? 'Aprovado' : 'Concluído', tom: 'success' };
  }
  if (progresso.statusEtapa === 'Aguardando_Escolha') return { rotulo: 'Aguardando escolha', tom: 'info' };
  if (progresso.statusEtapa === 'Pausado') return { rotulo: 'Pausado pelo aluno', tom: 'neutral' };
  if (estaParado(progresso)) return { rotulo: 'Parado há +48h', tom: 'warning' };
  return { rotulo: 'Em andamento', tom: 'info' };
}

export const pct = (parte, total) => (total > 0 ? Math.round((parte / total) * 100) : 0);

export const formatarNota = (valor) =>
  typeof valor === 'number' ? valor.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) : '—';

export const semAcento = (texto) =>
  String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export function exportarExcel(nomeArquivo, abas) {
  const livro = XLSX.utils.book_new();
  abas.forEach(({ nome, linhas }) => {
    XLSX.utils.book_append_sheet(livro, XLSX.utils.json_to_sheet(linhas.length ? linhas : [{ Aviso: 'Sem dados' }]), nome.slice(0, 31));
  });
  XLSX.writeFile(livro, nomeArquivo);
}
